// Components
import Grid from "@mui/material/Grid";

const ExamCardContainer = ({ isActive, children }) => {
  return (
    <Grid
      container
      display="flex"
      flexDirection="column"
      gap="8px"
      minWidth={{ xs: "350px", sm: "370px" }}
      maxWidth="450px"
      height="fit-content"
      padding="8px 16px"
      borderRadius="8px"
      boxShadow="-20px 0px 25px rgba(0, 0, 0, 0.05)"
      border="1px solid #5B6D7A"
      backgroundColor={isActive ? "#202338" : "#FFF"}
      flex={1}
    >
      {children}
    </Grid>
  );
};

export default ExamCardContainer;
